// @ts-nocheck v1

var currentClickedTab = null;

$(document).ready(function () {
    // Handle collection tab clicks
    $(document).on('click', '[ws-item="collection-tab"]', function (event) {
        currentClickedTab = $(this);
        var collectionHandle = $(this).data('collection');
        console.log('Clicked tab:', collectionHandle);

        // Get the specific shopify-section for this tab
        var currentSection = currentClickedTab.closest('.shopify-section');
        
        // Set active tab only within this section
        currentSection.find('[ws-item="collection-tab"]').removeClass('active');
        currentClickedTab.addClass('active');

        if (collectionHandle) {
            loadCollection(collectionHandle);
        }
    });
});

function loadCollection(handle) {
    console.log("Loading collection:", handle);

    $.when(
        $.get('/collections/' + handle + '.json'),
        $.get('/collections/' + handle + '/products.json'),
        $.get('/collections/' + handle + '?sections=ws-product-short-descs')
    ).done(function (collectionData, productsData, sectionData) {
        var collection = collectionData[0].collection;
        var products = productsData[0].products || [];

        var shortDescs = {};
        try {
            var html = sectionData[0]['ws-product-short-descs'];
            var jsonText = $(html).filter('script[data-short-descs]').text()
                        || $(html).find('script[data-short-descs]').text();
            shortDescs = JSON.parse(jsonText);
        } catch (e) {
            console.log("Failed to parse short descriptions", e);
        }

        products.forEach(function (product) {
            product._shortDesc = shortDescs[product.handle] || '';
        });

        console.log("Collection:", collection.title);
        console.log("Products:", products);

        updateContent(collection, products);
    }).fail(function () {
        console.log("Failed to load collection data");
    });
}

function updateContent(collection, products) {
    // Scope everything to the shopify-section containing the clicked tab
    var section = currentClickedTab.closest('.shopify-section');

    // Update collection title and description using ordered text-blocks
    var collectionTitleBlock = section.find('[ws-class="collection-title"]');
    var textBlocks = collectionTitleBlock.find('.text-block');

    // First text-block contains the title
    if (textBlocks.length > 0) {
        textBlocks.eq(0).find('p').text(collection.title);
    }

    // Second text-block contains the description
    if (textBlocks.length > 1) {
        var cleanDescription = $('<div>').html(collection.description).text();
        textBlocks.eq(1).find('p').html('<meta charset="utf-8"><span>' + cleanDescription + '</span>');
    }

    // Update collection footer button
    var collectionHandle = currentClickedTab.data('collection');
    var collectionUrl = '/collections/' + collectionHandle;
    section.find('[ws-class="collection-footer"] a').attr('href', collectionUrl);

    // Update button text and alt attributes if needed
    var buttonText = 'View ' + collection.title + ' Collection';
    section.find('[ws-class="collection-footer"] a').attr('title', buttonText);

    // Update product cards - scoped to this section only
    var cards = section.find('.resource-list .resource-list__item');
    var productsToShow = products.slice(0, 4);

    productsToShow.forEach(function (product, index) {
        if (index < cards.length) {
            var card = cards.eq(index);

            // Fix price calculation - prices are already in dollar format, no division needed
            var price = '$0.00';
            if (product.variants && product.variants.length > 0 && product.variants[0].price) {
                price = '$' + parseFloat(product.variants[0].price).toFixed(2);
            }

            var productUrl = '/products/' + product.handle;
            var variantId = product.variants && product.variants[0] ? product.variants[0].id : '';
            var fullUrl = variantId ? productUrl + '?variant=' + variantId : productUrl;

            var shortDesc;
            if (product._shortDesc) {
                shortDesc = product._shortDesc;
            } else {
                var cleanDesc = $('<div>').html(product.body_html).text();
                shortDesc = cleanDesc.length > 150 ? cleanDesc.substring(0, 150) + '...' : cleanDesc;
            }

            // Update all card elements
            card.find('product-card').attr({
                'data-product-id': product.id,
                'data-product-variants-size': product.variants ? product.variants.length : 1,
                'id': 'product-card-' + product.id
            });

            card.find('.product-card__link, .card-gallery .contents').attr('href', fullUrl);
            card.find('.product-card__link .visually-hidden').text(product.title);
            card.find('.card-gallery .contents').attr('aria-label', product.title);

            // Fix image updating - target the correct image element in slideshow
            if (product.images && product.images[0]) {
                card.find('slideshow-slide .product-media__image').attr({
                    'src': product.images[0].src,
                    'alt': product.title,
                    'srcset': product.images[0].src + ' 1x'
                });
            }

            card.find('h3').text(product.title);
            card.find('.price').text(price);
            card.find('product-price, .card-gallery').attr('data-product-id', product.id);

            // Find the group-block after card-gallery and update title and description in order
            var groupBlock = card.find('.card-gallery').siblings('.group-block').first();
            var textBlocks = groupBlock.find('.text-block');

            // First text-block contains the title (h3)
            if (textBlocks.length > 0) {
                textBlocks.eq(0).find('h3').text(product.title);
            }

            // Second text-block contains the description
            if (textBlocks.length > 1) {
                var descBlock = textBlocks.eq(1);
                var descP = descBlock.find('p');
                if (descP.length > 0) {
                    descP.html('<meta charset="utf-8"><span>' + shortDesc + '</span>');
                } else {
                    descBlock.text(shortDesc);
                }
            }

            // Update product-price elements
            card.find('product-price .price').text(price);

            card.show();
        }
    });

    // Hide unused cards
    for (var i = productsToShow.length; i < cards.length; i++) {
        cards.eq(i).hide();
    }

    console.log("Content updated");
}

function updateProductCards(products) {
    console.log("Updating product cards:", products.length);

    // Scope to the shopify-section containing the clicked tab
    const section = currentClickedTab.closest('.shopify-section');
    const cards = section.find('.resource-list .resource-list__item');

    const maxCards = Math.min(cards.length, 4);
    const productsToShow = products.slice(0, maxCards);

    // Update cards with product data
    productsToShow.forEach((product, index) => {
        if (index < cards.length) {
            updateSingleProductCard(cards.eq(index), product);
            cards.eq(index).show();
        }
    });

    // Hide remaining cards
    for (let i = productsToShow.length; i < cards.length; i++) {
        cards.eq(i).hide();
    }

    console.log("Cards updated");
}

function updateSingleProductCard(card, product) {
    // Fix price calculation - prices are already in dollar format
    let price = '$0.00';
    if (product.variants && product.variants.length > 0 && product.variants[0].price) {
        price = `$${parseFloat(product.variants[0].price).toFixed(2)}`;
    }

    const productUrl = `/products/${product.handle}`;
    const variantId = product.variants?.[0]?.id || '';
    const fullUrl = variantId ? `${productUrl}?variant=${variantId}` : productUrl;

    let shortDescription;
    if (product._shortDesc) {
        shortDescription = product._shortDesc;
    } else {
        const cleanDescription = $('<div>').html(product.body_html).text();
        shortDescription = cleanDescription.length > 150
            ? cleanDescription.substring(0, 150) + '...'
            : cleanDescription;
    }

    // Update product card attributes
    card.find('product-card').attr({
        'data-product-id': product.id,
        'data-product-variants-size': product.variants?.length || 1,
        'id': `product-card-${product.id}`
    });

    // Update links
    card.find('.product-card__link, .card-gallery .contents').attr('href', fullUrl);
    card.find('.product-card__link .visually-hidden').text(product.title);
    card.find('.card-gallery .contents').attr('aria-label', product.title);

    // Fix image updating - target slideshow image
    if (product.images && product.images[0]) {
        card.find('slideshow-slide .product-media__image').attr({
            'src': product.images[0].src,
            'alt': product.title,
            'srcset': product.images[0].src + ' 1x'
        });
    } else if (product.image) {
        card.find('slideshow-slide .product-media__image').attr({
            'src': product.image,
            'alt': product.title,
            'srcset': product.image + ' 1x'
        });
    }

    // Update titles
    card.find('h3').text(product.title);

    // Update prices
    card.find('.price').text(price);

    // Update product IDs
    card.find('product-price, .card-gallery').attr('data-product-id', product.id);

    // Find the group-block after card-gallery and update title and description
    const groupBlock = card.find('.card-gallery').siblings('.group-block').first();
    const textBlocks = groupBlock.find('.text-block');

    // First text-block contains the title (h3)
    if (textBlocks.length > 0) {
        textBlocks.eq(0).find('h3').text(product.title);
    }

    // Second text-block contains the description
    if (textBlocks.length > 1) {
        const descBlock = textBlocks.eq(1);
        const descP = descBlock.find('p');
        if (descP.length > 0) {
            descP.html(`<meta charset="utf-8"><span>${shortDescription}</span>`);
        } else {
            descBlock.text(shortDescription);
        }
    }

    // Update product-price elements (keep "Starting at" text)
    card.find('product-price .price').text(price);

    console.log("Updated card:", product.title);
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ws-slider').forEach(function (slider) {
        var dotsContainer = slider.parentElement.querySelector('.ws-slider-dots');
        if (!dotsContainer) return;

        var slides = Array.from(slider.children);
        if (slides.length < 2) return;

        slides.forEach(function (_, i) {
            var dot = document.createElement('button');
            dot.className = 'ws-slider-dot' + (i === 0 ? ' active' : '');
            dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            dot.dataset.index = i;
            dot.addEventListener('click', function () {
                slider.scrollTo({ left: slider.offsetWidth * parseInt(this.dataset.index), behavior: 'smooth' });
            });
            dotsContainer.appendChild(dot);
        });

        var dots = dotsContainer.querySelectorAll('.ws-slider-dot');
        slider.addEventListener('scroll', function () {
            var index = Math.round(slider.scrollLeft / slider.offsetWidth);
            dots.forEach(function (dot, i) {
                dot.classList.toggle('active', i === index);
            });
        });

        var speed = parseFloat(slider.dataset.wsSliderSpeed);
        if (!speed || speed <= 0) return;

        var intervalMs = speed * 1000;
        var autoTimer = null;
        var playing = true;

        var playPauseBtn = document.createElement('button');
        playPauseBtn.className = 'ws-slider-playpause';
        playPauseBtn.setAttribute('aria-label', 'Pause auto-slide');
        playPauseBtn.innerHTML = '<svg class="ws-slider-icon-pause" width="8" height="8" viewBox="0 0 12 12"><rect x="1" y="1" width="3.5" height="10" rx="1"/><rect x="7.5" y="1" width="3.5" height="10" rx="1"/></svg><svg class="ws-slider-icon-play" width="8" height="8" viewBox="0 0 12 12"><polygon points="2,1 11,6 2,11"/></svg>';
        dotsContainer.appendChild(playPauseBtn);

        function goToNext() {
            var current = Math.round(slider.scrollLeft / slider.offsetWidth);
            var next = (current + 1) % slides.length;
            slider.scrollTo({ left: slider.offsetWidth * next, behavior: 'smooth' });
        }

        function startAuto() {
            if (autoTimer) return;
            playing = true;
            dotsContainer.classList.remove('ws-slider-paused');
            playPauseBtn.setAttribute('aria-label', 'Pause auto-slide');
            autoTimer = setInterval(goToNext, intervalMs);
        }

        function pauseAuto() {
            clearInterval(autoTimer);
            autoTimer = null;
            playing = false;
            dotsContainer.classList.add('ws-slider-paused');
            playPauseBtn.setAttribute('aria-label', 'Play auto-slide');
        }

        startAuto();

        playPauseBtn.addEventListener('click', function () {
            if (playing) { pauseAuto(); } else { startAuto(); }
        });

        dots.forEach(function (dot) {
            dot.addEventListener('click', function () { pauseAuto(); });
        });

        var userScrolling = false;
        slider.addEventListener('pointerdown', function () { userScrolling = true; });
        document.addEventListener('pointerup', function () {
            if (userScrolling) { userScrolling = false; pauseAuto(); }
        });
    });
});
